// Copyright (c) 2017 Deere & Company

import DuplicatePinPlate from '../../product/duplicate-pin-plate/components/duplicate-pin-plate-form';

export default {
    component: DuplicatePinPlate,
    name: 'DUPLICATE_PIN_PLATE',
    path: 'duplicate-pin-plate'
};



// WEBPACK FOOTER //
// ./src/routes/products/duplicate-pin-plate.js